import type { useTranslation } from 'react-i18next';
import type { FailureMode, UsedPrecheckAnswer } from '../../../types/drbfm';

type TFunction = ReturnType<typeof useTranslation>['t'];

/** The evidence's own label, or the localized generic title when it has none. */
export const drawingEvidenceLabel = (
  t: TFunction,
  evidence: { label?: string | null } | null | undefined,
): string => evidence?.label || t('drbfm.drawingEvidence.title');

export const formatPercent = (value: number | undefined): string => (
  `${Math.round((value || 0) * 100)}%`
);

export const getSeverityLabel = (failureMode: FailureMode): string => (
  `${failureMode.severity} / ${failureMode.severityScore || '-'}`
);

export const buildReviewComment = (failureMode: FailureMode, t: TFunction): string => {
  const evidenceText = failureMode.knowledgeReferences.length > 0
    ? t('drbfm.decisionMemory.knowledgeLinked', '関連知識と照合済み')
    : t('drbfm.decisionMemory.knowledgeUnlinked', '関連知識は未紐付け');
  const questionText = failureMode.reviewQuestions?.length
    ? t('drbfm.decisionMemory.additionalReviewNeeded', '追加確認が必要')
    : t('drbfm.decisionMemory.noAdditionalQuestions', '追加質問なし');
  return t('drbfm.decisionMemory.reviewComment', {
    description: failureMode.failureDescription,
    rpn: failureMode.rpnScore || '-',
    evidenceText,
    questionText,
    defaultValue: `${failureMode.failureDescription}はRPN ${failureMode.rpnScore || '-'}。${evidenceText}、${questionText}としてレビューしてください。`,
  });
};

export const getPrecheckAnswerChipLabel = (answer: UsedPrecheckAnswer, t: TFunction): string => {
  switch (answer.status) {
    case 'answered':
      return answer.answer || answer.answerText || answer.answer_text || t('drbfm.case.answerStatus.answered', '回答済み');
    case 'unknown':
      return t('drbfm.case.answerStatus.unknown', '不明');
    case 'not_applicable':
      return t('drbfm.case.answerStatus.not_applicable', '該当なし');
    default:
      return t('drbfm.case.answerStatus.unanswered', '未回答');
  }
};
